import React from 'react';
import { FilterPills, FilterOption } from '@/components/common/FilterPills';

interface AskHubFilterPillsProps {
  currentCreatorFilter: string;
  onCreatorFilterChange: (filter: string) => void;
  currentPersonaFilter: string;
  onPersonaFilterChange: (filter: string) => void;
  creators: Array<{ id: string; name: string }>;
  personas: string[];
}

export const AskHubFilterPills: React.FC<AskHubFilterPillsProps> = ({
  currentCreatorFilter,
  onCreatorFilterChange,
  currentPersonaFilter,
  onPersonaFilterChange,
  creators,
  personas,
}) => {
  const creatorOptions: FilterOption[] = [
    { id: 'all', label: 'All Creators' },
    ...creators.map((c) => ({ id: c.id, label: c.name })),
  ];

  const personaOptions: FilterOption[] = [
    { id: 'all', label: 'All Personas' },
    ...personas.map((p) => ({ id: p, label: p })),
  ];

  return (
    <>
      <FilterPills
        label="Filter by Creator"
        options={creatorOptions}
        currentFilter={currentCreatorFilter}
        onFilterChange={onCreatorFilterChange}
      />
      <FilterPills
        label="Filter by Persona"
        options={personaOptions}
        currentFilter={currentPersonaFilter}
        onFilterChange={onPersonaFilterChange}
      />
    </>
  );
};
